import { useParams } from 'react-router-dom'

import SiteMessage from 'models/SiteMessage'

import NotFound from 'pages/NotFound'
import SiteMessageForm from 'pages/shared/SiteMessageForm'

import useSiteMessages from 'hooks/useSiteMessages'
import { useStoreContext } from 'hooks/StoreContext'

import { LoadingSinglePanePage, SinglePanePage } from 'styles/shared'

const EditSiteMessage = () => {
  useSiteMessages({ listForAllBrands: true })

  const { siteMessages, areSiteMessagesLoaded } = useStoreContext()
  const { id } = useParams()

  if (!areSiteMessagesLoaded) {
    return <LoadingSinglePanePage />
  }

  const siteMessage = _.find(siteMessages, (siteMessage) => siteMessage.id.toString() === id)

  if (!siteMessage) {
    return (
      <SinglePanePage>
        <NotFound />
      </SinglePanePage>
    )
  }

  return (
    <SinglePanePage>
      <SiteMessageForm
        title="Edit Site Message"
        validatedSaveType="update"
        siteMessage={new SiteMessage(siteMessage)}
      />
    </SinglePanePage>
  )
}

export default EditSiteMessage
